<template>
    <div class="emapm-form" :class="{'emapm-form-readonly':readonly}">
        <div v-for="(group,index) in groupMetas" :class="{'cellgroup-title-hidden':_getGroupName(group) === ' ','emapm-items':true}">
            <mt-cell-group :title="_getGroupName(group)" v-show="group.members.some(function(item){return !item.initParam.hidden;})">
                <div v-for="metaItem in group.members" v-show="!metaItem.initParam.hidden" class="emapm-item">
                    <slot :name="metaItem.name" :model="metaItem" :display-value.sync="value[metaItem.displayName]" :value="value[metaItem.name]" @sync-change="handleSyncChange" :ref="'field' + metaItem.name">
                        <component :model="metaItem" :is="componentMap['em' + metaItem.xtype] || componentMap['emtext']" v-model="value[metaItem.name]" @sync-change="handleSyncChange" :display-value.sync="value[metaItem.displayName]" :options="optionsMap[metaItem.name]" @click.native="_handleQueryDic(metaItem)" :ref="'field' + metaItem.name" :titlewidth="titlewidth" :textalign="textalign" :pid="pid"></component>
                    </slot>
                </div>
            </mt-cell-group>
            <!-- <div class="emapm-divide" v-show="group.members.some(function(item){return !item.initParam.hidden;})"></div> -->
        </div>
        <!-- <div class="emapm-divide"></div> -->
    </div>
</template>
<script>
import Components from './form-components.js';
import { parseParam, validate, queryDic } from './formUtils.js';

const DISPLAYPOSTFIX = '_DISPLAY';
const QUERYPOSTFIX = '_QUERY';

let getMetas = function(controls, readonly) {
    //debugger
    if (Array.isArray(controls)) {
        return controls.map(function(item) {
            if (!item.xtype) {
                item.xtype = 'text';
            }
            let meta = Object.assign({}, item);
            let jsonParam = parseParam(meta.JSONParam);
            meta.initParam = Object.assign({
                hidden: meta.hasOwnProperty('form.hidden') ? meta['form.hidden'] : meta.hidden,
                readonly: readonly || (meta.hasOwnProperty('form.readonly') ? meta['form.readonly'] : meta.readonly),
                placeholder: meta.hasOwnProperty('form.placeholder') ? meta['form.placeholder'] : meta.placeholder,
                required: meta.hasOwnProperty('form.required') ? meta['form.required'] : meta.required,
                disabled: false
            }, jsonParam);
            meta.displayName = meta.name + DISPLAYPOSTFIX;
            //附件上传只读，不做校验
            if (item.xtype === 'uploadfile') {
                meta.initParam.readonly = true;
            }
            if (item.xtype === 'textarea') {
                if (!meta.initParam.hasOwnProperty('textareaEasyCheck')) {
                    meta.initParam.textareaEasyCheck = true;
                }
            }
            return meta;
        });
    }
    return [];
};


export default {
    name: 'emapm-form',
    props: {
        model: {
            type: Array,
            default: function() {
                return [];
            }
        },
        action: { type: String },
        value: { type: Object, default () { return {}; } },
        customVm: {
            type: Object,
            default: function() {
                return {};
            }
        },
        readonly: {
            default: false
        },
        titlewidth: {
            type: String,
            default: function() {
                return '96px';
            }
        },
        textalign: {
            type: String,
            default: function() {
                return 'normal';
            }
        },
        pid: {
            type: String,
            default: function() {
                return null;
            }
        }
    },
    data() {
        return {
            currentValue: this.value,
            optionsMap: {},
            metas: getMetas(this.model, this.readonly),
            oldValue: Object.assign({}, this.value)
        };
    },
    created() {
        //debugger
        //console.log(this);
    },
    mounted(){
        var cellGroupTitleEle = document.querySelectorAll('.emapm-form.emapm-form-readonly .mint-cell-group-title');
        for (let index = 0; index < cellGroupTitleEle.length; index++) {
            const element = cellGroupTitleEle[index];
            //debugger
            if (element.innerText) {
                element.className += ' emap-cellgroup-hastitle';
            }else {
                element.className += ' emap-cellgroup-notitle';
            }
        }
    },
    computed: {
        componentMap() {
            let map = {};
            //debugger
            var mixComponents = Object.assign({},Components,window.emXtype||{});
            Object.keys(mixComponents).forEach(function(key) {
                map[key] = key;
            });
            return Object.assign({}, map, this.customVm);
        },
        //分组信息，表单渲染使用此模型
        groupMetas() {
            let groupMetas = {};
            this.metas.forEach(function(item) {
                let name = item.groupName || '无分组';
                if (groupMetas[name]) {
                    groupMetas[name].push(item);
                } else {
                    groupMetas[name] = [item];
                }
            });
            let keys = Object.keys(groupMetas);
            //debugger
            return keys.map(function(key) {
                return {
                    groupName: key,
                    members: groupMetas[key]
                };
            });
        }
    },
    watch: {
        value: {
            deep: true,
            handler(val) {
                let old = this.oldValue;
                let reg = new RegExp(DISPLAYPOSTFIX + '$');
                Object.keys(val).forEach((key) => {
                    if (reg.test(key)) {
                        return;
                    }
                    if (val[key] !== old[key]) {
                        //debugger
                        //处理赋值
                        this._queryDicByKey(key, val);
                        this._linkageVm(key, val[key]);
                    }
                });
                this.currentValue = val;
            }
        },
        currentValue: {
            deep: true,
            handler(val) {
                this.oldValue = Object.assign({}, val);
                this.$emit('input', val);
            }
        },
        model: {
            deep: true,
            handler(model) {
                this.metas = getMetas(model, this.readonly);
                // this._queryDicByParam();
            }
        },
        readonly() {
            this.metas = getMetas(this.model, this.readonly);
        }
    },

    methods: {
        //联动
        _linkageVm(key, val) {
            //console.log('key:'+key+',val:'+val)
            this.metas.forEach((metaItem) => {
                //console.log(metaItem)
                if (key === metaItem['form.linkageBy']) {
                    if (metaItem.url && !metaItem.initParam.readonly) {
                        //debugger
                        let name = metaItem.name;
                        let displayName = metaItem.displayName;
                        this.handleSyncChange('', name);
                        this.handleSyncChange('', displayName);
                        this.__queryDic(metaItem).then(rows => {
                            //debugger
                            if (rows && rows.length === 1) {
                                //debugger
                                this.handleSyncChange(rows[0].id, name);
                                this.handleSyncChange(rows[0].name, displayName);
                            } else {
                                //debugger
                                //this.handleSyncChange(rows[0].id, name);
                                //this.handleSyncChange(rows[0].name, displayName);
                                // console.log(rows)
                            }
                        });
                    }
                }
            });
        },
        _queryDicByKey(key, value) {
            this.metas.some((meta) => {
                if (key === meta.name) {
                    if (meta.url && !value[meta.displayName]) {
                        //debugger
                        this._handleQueryDic(meta);
                    }
                    return true;
                }
            });
        },
        _handleQueryDic(metaItem) {
            if (this.__canQueryDic(metaItem)) {
                // 会发生缓存字典的现象，每次都去请求最新的。两个form同一个字段，不同的字典。
                //let options = this.optionsMap[metaItem.name];
                //if (!options || options.length === 0) {
                    this.__queryDic(metaItem);
                //}
            }
        },
        __canQueryDic(metaItem) {
            if (metaItem.initParam.readonly || metaItem.initParam.disabled || metaItem.xtype === 'selecttable' || !metaItem.url) {
                return false;
            }
            return true;
        },
        __queryDic(metaItem, param) {
            let searchValue = [];
            this.metas.forEach((item) => {
                if (item.name === metaItem['form.linkageBy']) {
                    searchValue.push({
                        name: metaItem['form.linkageName'],
                        value: this.value[item.name],
                        builder: 'equal',
                        linkOpt: 'AND'
                    });
                }
            });
            let query = {};
            if (searchValue.length) {
                query = Object.assign(metaItem.queryParam || {}, { searchValue: JSON.stringify(searchValue) }, param);
            } else {
                query = Object.assign(metaItem.queryParam || {}, param);
            }
            //debugger
            if(metaItem.xtype.indexOf('tree')>-1){
                //debugger
                query.pId = ""
            }else {
                return queryDic(metaItem.url, query).then(rows => {
                    let name = metaItem.name;
                    this.$set(this.optionsMap, name, rows);
                    //debugger
                    return rows;
                });
            }  
        },
        //暂不使用
        _queryDicByParam() {
            this.metas.some((metaItem) => {
                if (this.__canQueryDic(metaItem)) {
                    let name = metaItem.name;
                    let displayName = metaItem.displayName;
                    //无值不查询
                    if (this.optionsMap[name] && this.optionsMap[name].length) {
                        let current = metaItem.url + JSON.stringify(metaItem.queryParam || {});
                        //判断查询条件是否有变化
                        if (current !== this.optionsMap[name + QUERYPOSTFIX]) {
                            this.__queryDic(metaItem).then(() => {
                                if (this.currentValue[displayName]) {
                                    this.currentValue[displayName] = '';
                                }
                                if (this.currentValue[name]) {
                                    this.currentValue[name] = '';
                                }
                            });
                        }
                    }
                }
            });
        },
        _getGroupName(group) {
            if (group.groupName.indexOf('无分组') != -1) {
                return '';
            } else if (group.groupName.indexOf('无') == -1) {
                return group.groupName;
            } else {
                return ' ';
            }
        },
        queryComponentDic(metaItem, param) {
            return this.__queryDic(metaItem, param);
        },
        handleSyncChange(val, name) {
            this.$set(this.currentValue, name, val);
        },
        _changeMetaValue(name, key, val) {
            if (name) {
                let metas = this.metas;
                var keys = key.split('.');
                let checkVal = function(m, keys, val) {
                    if (keys.length === 1) {
                        m[keys[0]] = val;
                    } else {
                        m[keys[0]][keys[1]] = val;
                    }
                };
                if (Array.isArray(name)) {
                    name.forEach((v) => {
                        metas.some(function(m) {
                            if (m.name === v) {
                                checkVal(m, keys, val);
                                return true;
                            }
                        });
                    });
                } else {
                    metas.some(function(m) {
                        if (m.name === name) {
                            checkVal(m, keys, val);
                            return true;
                        }
                    });
                }
            }
        },
        showItem(name) {
            this._changeMetaValue(name, 'initParam.hidden', false);
        },
        hideItem(name) {
            this._changeMetaValue(name, 'initParam.hidden', true);
        },
        disableItem(name) {
            this._changeMetaValue(name, 'initParam.readonly', true);
        },
        enableItem(name) {
            this._changeMetaValue(name, 'initParam.readonly', false);
        },
        requireItem(name) {
            this._changeMetaValue(name, 'initParam.required', true);
        },
        unRequireItem(name) {
            this._changeMetaValue(name, 'initParam.required', false);
        },
        validate() {
            var value = Object.assign({}, this.currentValue);
            this.metas.forEach((m) => {
                if (m.xtype === 'uploadsingleimage' || m.xtype === 'uploadmuiltimage') {
                    var $vm = this.getVmByName(m.name);
                    if ($vm.getImageUrls().length === 0) {
                        value[m.name] = '';
                    }
                }
            });
            return validate(this.metas, value);
        },
        getVmByName(name) {
            var $vms = this.$refs['field' + name];
            if ($vms) {
                return $vms[0];
            }
        }
    },
    components: Components
};
</script>
<style lang="css">
.emapm-form textarea,.emapm-form input,.emapm-form span{
    font-family: "PingFang SC","Microsoft YaHei","Times New Roman";
}
.emapm-form .mint-cell-group > .emapm-item .mint-cell:first-child .mint-cell-wrapper {
    border-top: .5PX solid #e8e8e8;
}
.emapm-form .mint-cell .mint-cell-value {
    padding: 8px 0;
}
.emapm-form .select-value {
     text-align: left; /* form 人事 孙新 add by jbxu 2018-11-26 */
}
.emapm-item {
    position: relative;
}
.emapm-item .mint-field .mint-cell-value.mt-color-grey-lv3 input {
    color: inherit;
}
.emapm-form .mint-cell-group .emapm-item:first-child .mint-cell-wrapper {
    border-top: none;
}
/* .emapm-form .mint-cell-group-title {
    padding: 16px 20px 16px;
    font-size: 16px;
    line-height: 16px;
} 
.emapm-form .mint-cell-group-title:before {
    content: "｜";
    color: #52C7CA;
    font-size: 12px;
    position: relative;
    top: -2px;
    left: -4px;
}

.emapm-form .cellgroup-title-hidden .mint-cell-group-title:before {
    content: "";
    font-size: 0
} */
.emapm-form .mint-cell-group-title {
    /* font-weight: 600;
    color: #1E2329; */
    padding: 12px 20px 12px;
}




/* .emapm-form.emapm-form-readonly .mint-hairline--top-bottom {
    position: inherit !important;
} */

.emapm-form input::-webkit-input-placeholder {
    font-weight: 400 !important;
}

.emapm-form input::-webkit-input-placeholder {
    font-weight: 400 !important;
}

.emapm-form input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    font-weight: 400 !important;
}

.emapm-form input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    font-weight: 400 !important;
}

.emapm-form input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    font-weight: 400 !important;
}

.emapm-form input {
    font-weight: 400 !important;
}

.emapm-form input:focus {
    font-weight: 400 !important;
}




/* 只读表单样式设置区 */

/* .emapm-form.emapm-form-readonly .mint-cell-group-title::before{
    content: ''
} */
.emapm-form.emapm-form-readonly .mint-cell-group-title {
    padding: 16px 20px 16px;
    font-size: 16px;
    line-height: 16px;
    color: #1E2329;
    background-color: #fff !important;
    /* padding: 10px 20px 10px;
    font-size: 14px;
    line-height: 14px;
    color: #92969c; */
}
.emapm-form.emapm-form-readonly .emapm-items {
    /* margin-bottom:10px; 
    border-top: solid 1px #f4f4f4;*/
}
.emapm-form.emapm-form-readonly .mint-cell-group .mint-cell-group-content .emapm-item .mint-cell {
    min-height:0px;
    padding:6px 0;
}
.emapm-form.emapm-form-readonly .mint-cell-group .mint-cell-group-content .emapm-item .mint-cell .mint-cell-wrapper{
    border-top-style: none;
    font-size: 14px;
}
.emapm-form.emapm-form-readonly .mint-cell .mint-cell-value {
    padding: 0;
    
}
.emapm-form.emapm-form-readonly .mint-cell .mint-cell-value .em-select-value,.emapm-form.emapm-form-readonly .mint-cell .mint-cell-value .mt-cell-diy-span {
    color: #1E2329 !important;
}
.emapm-form.emapm-form-readonly .mint-cell-group-content {
    /* padding-top:16px; */
    padding-bottom:10px; 
}
.emapm-form.emapm-form-readonly .mint-hairline--top-bottom:after {
    border-bottom-width:1px;
    border-top-width:0;
    border-color:#e8e8e8;
}
.emapm-form.emapm-form-readonly .mint-cell-group .emap-cellgroup-hastitle + .mint-cell-group-content .emapm-item:first-child {
    padding-top:10px;
    border-top:solid 1px #f4f4f4;
}
.emapm-form.emapm-form-readonly .mint-cell-group .emap-cellgroup-notitle {
    /* border-bottom:solid 1px #f4f4f4; */
    padding: 0;
}
.emapm-form.emapm-form-readonly .mint-cell-group .emap-cellgroup-notitle + .mint-cell-group-content .emapm-item:first-child{
    /* border-top:solid 1px #f4f4f4; */
    padding-top:16px;
}
.emapm-form.emapm-form-readonly .em-select-value,.emapm-form.emapm-form-readonly .mt-cell-diy-span {
    line-height: 16px;
}
.emapm-form.emapm-form-readonly .emapm-divide {
    height:10px;border-bottom: solid 1px #f4f4f4;
}
</style>


// WEBPACK FOOTER //
// emapm-form.vue?515e2052